import { maxBy } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'
import { Day } from '../common/Calendar/Day'
import { Attendance } from './Attendance'

// 2 Depth - 날짜별 출석들
export class AttendanceByDay {
  day: Day
  private attendanceMap = new ExtendedMap<Attendance['id'], Attendance>()

  constructor(day: Day, data?: res.Attendance[] | Attendance[]) {
    this.day = day
    if (data) {
      const attList =
        data[0] instanceof Attendance
          ? (data as Attendance[])
          : data.map((att) => new Attendance(att))

      this.attendanceMap = ExtendedMap.fromArr(attList, 'id')
    }

    makeAutoObservable(this)
  }

  get attCount() {
    let enter = 0
    let quit = 0
    for (const { quitDatetime } of this.toArr) {
      enter += 1
      if (quitDatetime) quit += 1
    }
    return { enter, quit }
  }

  get dateKey() {
    return this.day.toString
  }

  get toArr() {
    return this.attendanceMap.toArr
  }

  get lastAttendance() {
    return maxBy(this.attendanceMap.toArr, (data) => data.enterDatetime)
  }

  get(key: Attendance['id']) {
    return this.attendanceMap.get(key)
  }

  set(key: Attendance['id'], attendance: Attendance) {
    this.attendanceMap.set(key, attendance)
  }

  delete(key: Attendance['id']) {
    return this.attendanceMap.delete(key)
  }
}
